module.exports = __webpack_public_path__ + "static/icon-4-yellow-0249b9a5703bfbedf3fa9831280f3060.png";